import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFileDownload, FaBriefcase, FaCode, FaTools, FaFileAlt, FaEnvelope } from 'react-icons/fa';

const Navbar = () => {
  const location = useLocation();

  // Desktop navigation items (Home removed, logo serves as Home link)
  const desktopLinks = [
    { path: '/projects', label: 'Projects' },
    { path: '/services', label: 'Services' },
    { path: '/skills', label: 'Skills' },
    { path: '/cv', label: 'Resume' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  // Mobile bottom tab bar items (4 key tabs: Projects, SERVICES, RESUME, Contact)
  const mobileTabs = [
    { path: '/projects', label: 'Projects', icon: <FaCode size={18} /> },
    { path: '/services', label: 'Services', icon: <FaTools size={18} /> },
    { path: '/cv', label: 'Resume', icon: <FaFileAlt size={18} /> },
    { path: '/contact', label: 'Contact', icon: <FaEnvelope size={18} /> },
  ];

  return (
    <>
      {/* Top Fixed/Sticky Navbar Header */}
      <nav style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(7, 19, 37, 0.95)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(69, 170, 242, 0.2)',
        padding: '14px 28px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        {/* Brand Logo (Serves as Home Link) */}
        <div>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img
              src="/AdedejiwebuseX21ms.png"
              alt="Adedeji Babalola Logo"
              style={{ height: '42px', width: 'auto', borderRadius: '8px', objectFit: 'contain' }}
            />
          </Link>
        </div>

        {/* Desktop Navigation Links */}
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }} className="desktop-menu">
          {desktopLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                style={{
                  color: isActive ? '#45aaf2' : '#e2e8f0',
                  textDecoration: 'none',
                  fontWeight: isActive ? '700' : '500',
                  fontSize: '0.95rem',
                  padding: '6px 12px',
                  borderRadius: '8px',
                  background: isActive ? 'rgba(69, 170, 242, 0.12)' : 'transparent',
                  borderBottom: isActive ? '2px solid #45aaf2' : '2px solid transparent',
                  transition: 'all 0.2s ease',
                }}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* Action Buttons for HR & Clients */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }} className="desktop-buttons">
          <Link
            to="/cv"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              borderRadius: '20px',
              border: '1px solid rgba(69, 170, 242, 0.4)',
              color: '#45aaf2',
              background: 'rgba(69, 170, 242, 0.1)',
              textDecoration: 'none',
              fontSize: '0.88rem',
              fontWeight: '600',
              transition: 'all 0.2s ease',
            }}
          >
            <FaFileDownload /> Get Resume (PDF)
          </Link>
          <Link
            to="/contact"
            className="btn-primary"
            style={{
              padding: '8px 20px',
              fontSize: '0.88rem',
            }}
          >
            <FaBriefcase /> Hire / Contract
          </Link>
        </div>
      </nav>

      {/* Mobile Fixed Bottom Navigation Tab Bar (4 key tabs: Projects, SERVICES, RESUME, Contact) */}
      <nav
        className="mobile-bottom-nav"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: '62px',
          backgroundColor: 'rgba(5, 15, 29, 0.96)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderTop: '1px solid rgba(69, 170, 242, 0.3)',
          zIndex: 1000,
          display: 'none', // Shown via media query in index.css
          justifyContent: 'space-around',
          alignItems: 'center',
          padding: '0 8px',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.5)',
        }}
      >
        {mobileTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '3px',
                color: isActive ? '#45aaf2' : '#94a3b8',
                textDecoration: 'none',
                fontSize: '0.75rem',
                fontWeight: isActive ? '700' : '500',
                width: '25%',
                height: '100%',
                transition: 'all 0.2s ease',
              }}
            >
              <div style={{
                color: isActive ? '#45aaf2' : '#94a3b8',
                transform: isActive ? 'scale(1.1)' : 'scale(1)',
                transition: 'all 0.2s ease'
              }}>
                {tab.icon}
              </div>
              <span>{tab.label}</span>
            </Link>
          );
        })}
      </nav>
    </>
  );
};

export default Navbar;
